import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type RadioGroupProps = Omit<RadixRadioGroup.RadioGroupProps, 'asChild'>;

export const RadioGroup = memo(({ children, className, ...restOfProps }: RadioGroupProps) => {
  return (
    <RadixRadioGroup.Root className={cn('flex flex-col gap-3', className)} {...restOfProps}>
      {children}
    </RadixRadioGroup.Root>
  );
});

RadioGroup.displayName = 'RadioGroup';
